export interface WatchlistCustomerDomains {
  summary: {
    score: number;
    status: RiskStatusType;
    firstSeen: number;
    precision: number;
  };
  identity: {
    emailValid: true;
    emailFirstSeen: number;
    emailToName: string;
    emailLastSeen: number;
    phoneValid: boolean;
    phoneLineType: string;
    phoneFirstSeen: number;
    phoneToName: string;
    phoneToAddress: string;
    phoneLastSeen: number;
    phoneCarrier: string;
    phoneEmailFirstSeen: number;
    addressValidityLevel: string;
    addressToName: string;
    ipPhoneDistance: number;
    ipAddressDistance: number;
    ipLastSeen: number;
    ipCountryCode: string;
    ipSubdivision: string;
  };
  socialMedia: {
    accounts: SocialMediaResponse[];
    breaches: BreachesResponse[];
  };
  domain: DomainResponse;
}

export interface DomainResponse {
  name: string;
  exists: string;
  domainName: string;
  registrantName: string;
  organization: string;
  registrantStreet: string;
  registrantCity: string;
  registrantStateProvince: string;
  registrantPhone: string;
  registryDomainId: string;
  nameservers: string[];
  registrarName: string;
  abuseContactEmail: string;
  abuseContactPhone: string;
  created: string;
  updated: string;
  registryExpiration: string;
  lastUpdatedTime: number;
  type: string;
  displayName: string;
}

export interface DataBreachesResponse {
  type: string;
  exists: SocialMediaState;
  firstSeen: number;
  lastSeen: number;
  lastUpdatedTime: number;
  breaches: Array<BreachesResponse>;
}

export interface BreachesResponse {
  accountType: string;
  name: string;
  title: string;
  domain: string;
  breachDate: string;
  addedDate: string;
  modifiedDate: string;
  pwnCount: string;
  description: string;
  logoPath: string;
  dataClasses: string;
}

export interface SocialMediaResponse {
  name: SocialMediaType;
  type: LookupType;
  status: SocialMediaStatus;
  lastUpdatedTime: number;
  avatar: string;
  attachments: Object;
}

export enum SocialMediaStatus {
  FOUND = 'FOUND',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
}

export enum LookupType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  IP = 'IP',
  CARD_BIN = 'CARD_BIN',
  ALL = 'ALL',
}

export enum SocialMediaType {
  Gmail = 'Gmail',
  MailRu = 'MailRu',
  Outlook = 'Outlook',
  YahooMail = 'YahooMail',
  YandexMail = 'YandexMail',
  Bitmoji = 'Bitmoji',
  Discord = 'Discord',
  Facebook = 'Facebook',
  Imgur = 'Imgur',
  Instagram = 'Instagram',
  Myspace = 'Myspace',
  Parler = 'Parler',
  Patreon = 'Patreon',
  Pinterest = 'Pinterest',
  Plurk = 'Plurk',
  Snapchat = 'Snapchat',
  Strava = 'Strava',
  Tellonym = 'Tellonyum',
  Tumblr = 'Tumblr',
  Twitter = 'Twitter',
  Vsco = 'Vsco',
  Wattpad = 'Wattpad',
  Github = 'Github',
  Skype = 'Skype',
  Wordpress = 'Wordpress',
  Quora = 'Quora',
}

export interface BreachesResponse {
  accountType: string;
  name: string;
  title: string;
  domain: string;
  breachDate: string;
  addedDate: string;
  modifiedDate: string;
  pwnCount: string;
  description: string;
  logoPath: string;
  dataClasses: string;
}

export interface CustomerRequest {
  phone: string | null;
  email: string | null;
  hideDetails: boolean;
  useCache: boolean;
}

export enum RiskStatusType {
  SAFE = 'SAFE',
  SUSPICIOUS = 'SUSPICIOUS',
  RISKY = 'RISKY',
}

export enum SocialMediaState {
  EXISTS = 'EXISTS',
  NOT_EXISTS = 'NOT_EXISTS',
  UNKNOWN = 'UNKNOWN',
}
